import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import { forkJoin } from 'rxjs';

import { AuthUser } from '@app/account/account-api.model';

import { DgxCurrencyPipe } from '@app/shared/pipes/currency.pipe';
import { AuthService } from '@app/shared/services/auth.service';
import { NavigationService } from '@app/shared/services/navigation.service';
import { WindowToken } from '@app/shared/window.token';
import { UserSummaryService } from '../../services/user-summary.service';
import { LearnerHomeTrackerService } from '@app/learner-home/services/learner-home-tracker.service';
import { LDFlagsService } from '@dg/shared-services';

@Component({
  selector: 'dgx-user-summary',
  templateUrl: './user-summary.component.html',
  styleUrls: ['./user-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserSummaryComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  public authUser: AuthUser;
  public isLoading: boolean = true;
  public masteryPoints: string;
  public flexEdAvailableBalance: string;
  public profileUrl: string;

  public showPoints = !this.ldFlagService.profile.pointsDecomission;

  constructor(
    private learnerHomeTrackerService: LearnerHomeTrackerService,
    private authService: AuthService,
    private userSummaryService: UserSummaryService,
    private navigationService: NavigationService,
    private dgxCurrencyPipe: DgxCurrencyPipe,
    private cdr: ChangeDetectorRef,
    private ldFlagService: LDFlagsService,
    @Inject(WindowToken) private windowRef: Window
  ) {
    super();
  }

  get flexEdUrl(): string {
    let url: string;
    const profileUrl = this.authUser.viewerProfile.profileUrl;
    url = `/profile/${profileUrl}/flex-ed`;
    return url;
  }

  public ngOnInit() {
    this.authUser = this.authService?.authUser;
    this.profileUrl = this.navigationService.getUserProfileUrl(
      this.authUser.viewerProfile.profileUrl
    );

    forkJoin({
      flexEd: this.userSummaryService.getFlexEd(),
      masteryPoints: this.userSummaryService.getMasteryPoints(false),
    })
      .pipe(this.takeUntilDestroyed())
      .subscribe(({ flexEd, masteryPoints }) => {
        this.flexEdAvailableBalance = flexEd?.availableBalance
          ? this.dgxCurrencyPipe.transform(flexEd.availableBalance, 2, false)
          : '';
        this.masteryPoints = masteryPoints;
        this.isLoading = false;
        this.cdr.markForCheck();
      });
  }

  public navigateToProfile() {
    this.trackClick('Avatar');
    this.windowRef.location.href = this.profileUrl;
  }

  public trackClick(itemClicked: string) {
    this.learnerHomeTrackerService.navigationClicked({
      itemClicked,
      context: 'Sidebar',
    });
  }
}
